namespace RioERP.Users {
    export interface FranchiseeForm {
        Name: Serenity.StringEditor;
        Description: Serenity.TextAreaEditor;
        Email: Serenity.EmailEditor;
        AlternateEmail: Serenity.EmailEditor;
        Mobile: Serenity.StringEditor;
        AlternateMobile: Serenity.StringEditor;
        AffiliateId: Serenity.StringEditor;
        Address: Serenity.StringEditor;
        City: Serenity.StringEditor;
        StateId: Serenity.LookupEditor;
        AvailableCreditBalance: Serenity.IntegerEditor;
        IsGstInApplied: Serenity.BooleanEditor;
        Gstin: Serenity.StringEditor;
        Pan: Serenity.StringEditor;
        GstCertificate: Serenity.MultipleImageUploadEditor;
        BankName: Serenity.StringEditor;
        BankAccountType: Serenity.EnumEditor;
        BankAccountName: Serenity.StringEditor;
        BankAccountNo: Serenity.StringEditor;
        BankIfscCode: Serenity.StringEditor;
        Pincode: Serenity.IntegerEditor;
        DiscountCoupon: Serenity.StringEditor;
        IsPostPayAllowed: Serenity.BooleanEditor;
        IsCustomer: Serenity.BooleanEditor;
        CustomerId: Serenity.LookupEditor;
    }

    export class FranchiseeForm extends Serenity.PrefixedContext {
        static formKey = 'Users.Franchisee';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FranchiseeForm.init)  {
                FranchiseeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;
                var w2 = s.EmailEditor;
                var w3 = s.LookupEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.BooleanEditor;
                var w6 = s.MultipleImageUploadEditor;
                var w7 = s.EnumEditor;

                Q.initFormType(FranchiseeForm, [
                    'Name', w0,
                    'Description', w1,
                    'Email', w2,
                    'AlternateEmail', w2,
                    'Mobile', w0,
                    'AlternateMobile', w0,
                    'AffiliateId', w0,
                    'Address', w0,
                    'City', w0,
                    'StateId', w3,
                    'AvailableCreditBalance', w4,
                    'IsGstInApplied', w5,
                    'Gstin', w0,
                    'Pan', w0,
                    'GstCertificate', w6,
                    'BankName', w0,
                    'BankAccountType', w7,
                    'BankAccountName', w0,
                    'BankAccountNo', w0,
                    'BankIfscCode', w0,
                    'Pincode', w4,
                    'DiscountCoupon', w0,
                    'IsPostPayAllowed', w5,
                    'IsCustomer', w5,
                    'CustomerId', w3
                ]);
            }
        }
    }
}
